import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';



const styles = {
    successColor: {
        color: "#52602B",
    },
    errorColor: {
        color: "#F44336"
    }
};


class SignIn extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSignIn: false,
            login: false,
            submitMessage: "",
            open: false,
        }
    }

    formSubmitClick() {
        let mail = document.querySelector('#loginMail').value;
        let pass = document.querySelector('#loginPass').value;

        let user;
        fetch("https://saydamalbum.com/saydamWebservice/login.php", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: "companyMail=" + mail
            + "&companyPass=" + pass
        }).then((response) => {
            return response.json();
        }).then((data) => {
            console.log(data);
            if (data.responseType === 200) { // Eğer giriş yaptıysa
                this.setState({
                    submitMessage: 'Girişiniz başarılı, yönlendiriliyorsunuz..',
                    open: true,
                });

                setTimeout(() => {
                    document.querySelector('#signInForm').submit()
                }, 2000);

                localStorage.setItem("ownerName", data.data.ownerName);
                localStorage.setItem("companyName", data.data.companyName);
                localStorage.setItem("companyMail", data.data.companyMail);
                localStorage.setItem("companyPhone", data.data.companyPhone);
                localStorage.setItem("companyAdress", data.data.companyAdress);
            } else {
                this.setState({
                    submitMessage: "Yanlış kullanıcı adı yada şifre girdiniz.",
                    open: true,
                    isSignIn: false,
                });
            }
        });
    }

    snackbarClose = () => {
        this.setState({
            open: false,
        });
    };

    render() {
        return (
            <form className="signIn" id="signInForm">
                <h4><span> Firma Girişi </span></h4>

                <div className="text-center">
                    <TextField
                        id="loginMail"
                        floatingLabelText="E-Posta Adresiniz"
                        type="email"
                    />
                </div>
                <div className="text-center">
                    <TextField
                        id="loginPass"
                        floatingLabelText="Parolanız"
                        type="password"
                    />
                </div>

                <div className="text-center buttonDiv">
                    <RaisedButton
                        label="Giriş Yap"
                        labelPosition="before"
                        icon={<i className="material-icons">send</i>}
                        backgroundColor="#2c3e50"
                        color="#fff"
                        type="button"
                        onClick={this.formSubmitClick.bind(this)}
                    />
                </div>

                <Snackbar
                    open={this.state.open}
                    message={this.state.submitMessage}
                    autoHideDuration={2000}
                    onRequestClose={this.snackbarClose}
                />

            </form>
        );
    }
}

export default SignIn;


// WEBPACK FOOTER //
// ./src/sign/signIn.js